import React, { useState, useEffect } from "react";

function get(obj, path, fallback) {
  var result = obj;
  var parts = path.split(".");
  for (var i = 0; i < parts.length; i++) {
    if (result === null || result === undefined) return fallback;
    result = result[parts[i]];
  }
  return result === undefined || result === null ? fallback : result;
}

function formatValue(val) {
  if (val === null || val === undefined) return "\u2014";
  if (Array.isArray(val)) {
    var clean = val.filter(function (v) {
      return v !== null && v !== undefined && v !== "";
    });
    return clean.length ? clean.join(", ") : "\u2014";
  }
  return String(val);
}

function AmazonProductListingEditableField({ field = {}, onFieldChange }) {
  var listingVal = formatValue(get(field, "listing.value", null));
  var initial = listingVal === "\u2014" ? "" : listingVal;

  var [value, setValue] = useState(initial);

  var isDropdown = get(field, "ui.input_type", "") === "dropdown";
  var options = get(field, "schema.allowed_values", []) || [];
  var isEditable = get(field, "schema.editable", true);
  // var isEditable = field.field === "country_of_origin" ? false : get(field, "schema.editable", true);

  var inputStyle = {
    width: "100%", 
    fontSize: 12, 
    padding: "4px 8px", 
    borderRadius: 6,
    border: isEditable ? "0.5px solid #ccc" : "1px solid red", 
    background: "var(--color-background-primary, #fff)", 
    color: isEditable ? "#333" : "#888", 
    cursor: isEditable ? "text" : "default" 
  };

  const handleChange = (newVal) => {
    if (!isEditable) return; 

    setValue(newVal);
    if (onFieldChange) {
      onFieldChange({
        field: field.field,
        value: newVal 
      });
    }
  };

  useEffect(() => {
    setValue(initial);
  }, [initial]);

  if (isDropdown) {
    return (
      <select 
        style={inputStyle} 
        value={value} 
        onChange={(e) => handleChange(e.target.value)}
        disabled={!isEditable} 
      >
        <option value="">Select</option>
        {options.map((opt) => (
          <option key={String(opt)} value={String(opt)}>{String(opt)}</option>
        ))}
      </select>
    );
  }

  return (
    <input
      type="text"
      style={inputStyle}
      value={value}
      onChange={(e) => handleChange(e.target.value)}
      readOnly={!isEditable} 
    />
  );
}

export default AmazonProductListingEditableField;